module.exports = __webpack_public_path__ + "img/chemical-plant.f1140471.png";